import * as React from 'react';

/**
 * ⚠️ CURRENTLY UNREFERENCED (2026-08-08, UI-43). Its only consumer was the footer's
 * icon-only social row, which the footer restructure replaced with text + an outbound
 * arrow. Kept rather than deleted because it is the one BRAND MARK the change discards
 * outright (Facebook/Instagram/YouTube came from lucide, which is still installed), so
 * restoring Threads iconography later should not mean redrawing it.
 *
 * Recorded here deliberately: an unreferenced file with no note is invisible: nobody
 * re-checks it. If a future sweep wants it gone, this comment is the permission.
 */

interface ThreadsIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

/**
 * ThreadsIcon — outline Threads glyph drawn to lucide-react's render spec
 * (24×24 viewBox, fill none, stroke=currentColor, strokeWidth 2, round
 * caps/joins). lucide-react ships no Threads icon, so this hand-rolled
 * component lets the footer social row render Threads consistently alongside
 * the lucide Facebook / Instagram / Youtube icons — same stroke weight, same
 * currentColor inheritance, same sizing via className. Mixed source, uniform
 * visual.
 */
const ThreadsIcon = React.forwardRef<SVGSVGElement, ThreadsIconProps>(
    ({ size = 24, ...props }, ref) => (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <path d="M19 7.5c-1.333 -2.667 -3.333 -4 -6 -4c-4 0 -6.5 3 -6.5 8.5s2.5 8.5 6.5 8.5c3.5 0 5.5 -2 5.5 -4.5c0 -3 -2.5 -4 -4.5 -4c-1.5 0 -3 .5 -3 2.5c0 1.5 1 2 2 2c1.5 0 2.5 -1.5 2.5 -3.5c0 -2.5 -2 -4 -4.5 -4" />
        </svg>
    )
);
ThreadsIcon.displayName = 'ThreadsIcon';

export default ThreadsIcon;
